import script from "./LanguageSelector.vue?vue&type=script&lang=ts&setup=true"
export * from "./LanguageSelector.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__